export class UserLogin{
  constructor(username, password){
    this.username = username;
    this.password = password;
  }
}